module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "open": _vm.showOver,
      "dialogClass": "game-over-dialog"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("完成了   " + _vm._s(_vm.score.name))])]), _vm._v(" "), _c('mu-row', {
    staticClass: "center-style",
    attrs: {
      "gutter": ""
    }
  }, [_c('div', [_vm._v("本局得分")])]), _vm._v(" "), _c('mu-row', {
    staticClass: "center-style",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', [_c('div', {
    staticClass: "scoreLine"
  }, [_c('div', {
    staticClass: "left-wrap"
  }, [_c('span', {
    staticClass: "lines lines-left"
  }), _c('span', {
    staticClass: "diamond diamond-left"
  })]), _vm._v(" "), (_vm.gameFlag == 1 && _vm.score.score >= 0) ? _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.score.score))]) : (_vm.gameFlag == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.score.transcript.score))]) : _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.score.todayPoints))]), _vm._v(" "), _c('div', {
    staticClass: "right-wrap"
  }, [_c('span', {
    staticClass: "diamond diamond-right"
  }), _c('span', {
    staticClass: "lines lines-right"
  })])])])], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "center-style",
    attrs: {
      "gutter": ""
    }
  }, [(_vm.tempFlag != 1) ? _c('mu-col', [(_vm.gameFlag == 1) ? _c('div', {
    staticClass: "last-desc"
  }, [_vm._v("上次得分\n        "), _c('span', {
    staticClass: "last-score"
  }, [_vm._v(_vm._s(_vm.score.lastScore))]), _vm._v(" 分\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gameFlag != 1) ? _c('mu-col', [_c('div', {
    staticClass: "center-style"
  }, [(_vm.tempFlag != 1) ? _c('span', [(_vm.score.yesterdayPoints == 0) ? _c('span', [_vm._v("上次得分 "), _c('b', {
    staticClass: "blackfontscore"
  }, [_vm._v("-")]), _vm._v(" 分")]) : _c('span', [_vm._v("上次得分 "), _c('b', {
    staticClass: "blackfontscore"
  }, [_vm._v(_vm._s(_vm.score.yesterdayPoints))]), _vm._v(" 分")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "last-desc"
  }, [_c('span', [_vm._v("正确题数/总题数 "), _c('b', {
    staticClass: "blackfontscore"
  }, [_vm._v(_vm._s(_vm.score.rightNumber) + "/" + _vm._s(_vm.score.totalNumber))]), _vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("正确率 "), _c('b', {
    staticClass: "blackfontscore"
  }, [_vm._v(_vm._s(_vm.score.rightDate))])])])]) : _vm._e()], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "center-style",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', [(_vm.showAll) ? _c('div', {
    staticClass: "all-desc"
  }, [_c('div', [_vm._v("恭喜！您已完成今日所有训练任务！")]), _vm._v(" "), _c('div', [_vm._v("明天继续加油~")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.game.id > 200) ? _c('div', {
    staticClass: "interationl",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', {}, [_vm._v("专业解读:")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.game.pro_interpretation) + "   \n            "), _c('span', {
    staticClass: "reference-id",
    staticStyle: {
      "color": "#0a81e5"
    },
    on: {
      "click": _vm.ReferenceConfirm
    }
  }, [_c('sup', [_vm._v(_vm._s(_vm.showRefer))])])])]) : _vm._e(), _vm._v(" "), (_vm.showPro) ? _c('div', {
    staticClass: "pro-Inter"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "30px"
    }
  }, [_c('h5', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "background-color": "rgb(209,209,209)",
      "margin-top": "0px",
      "height": "20px",
      "width": "100%"
    }
  }, [_vm._v("参考文献")]), _vm._v(" "), _c('div', {
    staticClass: "closeX",
    staticStyle: {
      "border-style": "none"
    },
    on: {
      "click": _vm.ReferenceConfirm
    }
  }, [_c('img', {
    staticStyle: {
      "background-color": "rgb(209,209,209)"
    },
    attrs: {
      "src": require("../../assets/img/icon_close.png")
    }
  })])]), _vm._v(" "), _vm._l((_vm.ReferObj), function(value, key, index) {
    return _c('p', {
      staticStyle: {
        "font-size": "14px",
        "word-wrap": "break-word",
        "word-break": "break-all",
        "margin-left": "4px",
        "margin-right": "4px"
      }
    }, [_vm._v("\n           " + _vm._s(key) + _vm._s(value) + "\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "btn-style",
    staticStyle: {
      "color": "#444",
      "margin-left": "60px",
      "border-radius": "0px",
      "left": "50%"
    },
    attrs: {
      "label": "返回"
    },
    on: {
      "click": _vm.return2Today
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "btn-style",
    staticStyle: {
      "border-radius": "0px",
      "left": "55%"
    },
    attrs: {
      "label": "再练一次",
      "disabled": _vm.forbid,
      "primary": ""
    },
    on: {
      "click": _vm.restart
    }
  }), _vm._v(" "), (_vm.showNextButton) ? _c('mu-raised-button', {
    staticClass: "btn-style",
    staticStyle: {
      "margin-left": "20px",
      "border-radius": "0px",
      "right": "10%"
    },
    attrs: {
      "label": "下一个训练",
      "disabled": _vm.forbid,
      "primary": ""
    },
    on: {
      "click": _vm.nextGame
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6083d781!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/gameOver.vue
// module id = 996
// module chunks = 2